(() => {
  if (window.EcomhardGaleriaLookInitialized) return;
  window.EcomhardGaleriaLookInitialized = true;

  const openClass = 'ecomhard-gallery-look-open';

  function closeModal(modal) {
    if (!modal) return;

    const opener = modal._ecomhardGalleryOpener;
    const trigger = document.querySelector(`[data-ecomhard-gallery-open="${modal.id}"]`);

    modal.classList.remove('is-open');
    modal.hidden = true;
    document.body.classList.remove(openClass);

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }

    if (opener && typeof opener.focus === 'function') {
      opener.focus();
    }
  }

  function openModal(modal, opener) {
    if (!modal) return;

    document.querySelectorAll('.ecomhard-gallery__look-modal.is-open').forEach((openModalItem) => {
      if (openModalItem !== modal) closeModal(openModalItem);
    });

    modal.hidden = false;
    modal.classList.add('is-open');
    modal._ecomhardGalleryOpener = opener;
    document.body.classList.add(openClass);

    if (opener) {
      opener.setAttribute('aria-expanded', 'true');
    }

    window.setTimeout(() => {
      const closeButton = modal.querySelector('[data-ecomhard-gallery-close]');
      if (closeButton) closeButton.focus();
    }, 0);
  }

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest('[data-ecomhard-gallery-open]');

    if (openTrigger) {
      event.preventDefault();
      event.stopPropagation();
      openModal(document.getElementById(openTrigger.dataset.ecomhardGalleryOpen), openTrigger);
      return;
    }

    const closeTrigger = event.target.closest('[data-ecomhard-gallery-close]');
    if (closeTrigger) {
      event.preventDefault();
      closeModal(closeTrigger.closest('.ecomhard-gallery__look-modal'));
      return;
    }

    const modal = event.target.closest('.ecomhard-gallery__look-modal');
    if (modal && event.target === modal) {
      closeModal(modal);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const modal = document.querySelector('.ecomhard-gallery__look-modal.is-open');
    if (modal) closeModal(modal);
  });
})();
